/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Box } from "@mui/material";

export const StyledSourceChip = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'source',
})(({ source }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getColorCode(source)}20`,
  color: getColorCode(source),
}));

const getColorCode = (source) => {
  switch (source) {
    case 'seven_shifts':
      return '#61b2fa'
  }
}
